import { IZone } from "interfaces/zone.interface";

import { NotificationHandlers } from "./notificationHandlers/NotificationHandlers";

import NotificationLogsAndFilters from "../../../components/NotificationRulesAndLogs";

type NotificationScreenProps = {
  zone: IZone;
  zones: IZone[];
};

export function NotificationScreen({ zone, zones }: NotificationScreenProps) {
  return (
    <>
      <NotificationHandlers zone={zone} zones={zones} />
      <NotificationLogsAndFilters
        type={"zone"}
        entityId={zone.id}
        zone={zone}
        zones={zones}
      />
    </>
  );
}
